import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import filtersReducer from '../features/filters/filterSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    filters: filtersReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Firebaseの認証状態オブジェクトは非シリアライズ可能なので、チェックから除外
        ignoredActions: ['auth/setUser'],
        ignoredPaths: ['auth.user'],
      },
    }),
});

export default store;
